/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import { useLocation } from "react-router";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { NavLink, useHistory } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
import { RoleChecker } from "../../../../../app/RoleChecker";
import PaymentIcon from "@material-ui/icons/Payment";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import StorageIcon from "@material-ui/icons/Storage";
import ShowChartIcon from "@material-ui/icons/ShowChart";
import AccessibilityNewIcon from "@material-ui/icons/AccessibilityNew";
import BusinessIcon from "@material-ui/icons/Business";
import CallSplitIcon from "@material-ui/icons/CallSplit";
import ShareIcon from "@material-ui/icons/Share";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import FolderIcon from "@material-ui/icons/Folder";
import DescriptionIcon from "@material-ui/icons/Description";
import { useFeatureChecker } from "../../../../../app/useFeatureChecker";
import { useRoleChecker } from "../../../../../app/useRoleChecker";

export function AsideMenuList({ layoutProps }) {
  const history = useHistory();
  const location = useLocation();

  const CheckFeature = useFeatureChecker();
  const CheckRole = useRoleChecker();

  function getMenuItemActive(url, hasSubmenu = false) {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu && "menu-item-active"} menu-item-open `
      : "";
  }

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dashboard">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} />
            </span>
            <span className="menu-text">Dashboard</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
        {/* <li
          className={`menu-item ${getMenuItemActive("/builder", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/builder">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Home/Library.svg")} />
            </span>
            <span className="menu-text">Layout Builder</span>
          </NavLink>
        </li> */}
        {/*end::1 Level*/}

        {/* Menu List */}
        {/* begin::section */}
        <li className="menu-section ">
          <h4 className="menu-text">Daftar Menu</h4>
          <i className="menu-icon flaticon-more-v2"></i>
        </li>
        {/* end:: section */}

        {/* Donasi */}
        {/*begin::1 Level*/}
        <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/donasi",
            true
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to="/donasi">
            <span className="svg-icon menu-icon">
              <PaymentIcon />
            </span>
            <span className="menu-text" onClick={() => history.push("/donasi")}>
              Donasi
            </span>
            <span className="menu-text" style={{ width: "100px" }}></span>
            <i className="menu-arrow" />
          </NavLink>
          <div className="menu-submenu ">
            <i className="menu-arrow" />
            <ul className="menu-subnav">
              {/* Daftar Donasi */}
              {/*begin::2 Level*/}
              {RoleChecker("Read", "list_donasi") && (
                <li
                  className={`menu-item menu-item-submenu ${getMenuItemActive(
                    "/donasi/list",
                    true
                  )}`}
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                >
                  <NavLink className="menu-link menu-toggle" to="/donasi/list">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Daftar Donasi Konter</span>
                  </NavLink>
                </li>
              )}
              {/*end::2 Level*/}

              {/* Daftar Donasi */}
              {/*begin::2 Level*/}
              {RoleChecker("Read", "bank") && (
                <>
                    <li
                      className={`menu-item menu-item-submenu ${getMenuItemActive(
                        "/donasi/bank-import",
                        true
                      )}`}
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                    >
                      <NavLink
                        className="menu-link menu-toggle"
                        to="/donasi/bank-import"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Daftar Donasi Bank</span>
                      </NavLink>
                    </li>
                </>
              )}
              {/*end::2 Level*/}

              {/* Input Donasi */}
              {/*begin::2 Level*/}
              {RoleChecker("Read", "list_donasi") && (
                <li
                  className={`menu-item menu-item-submenu ${getMenuItemActive(
                    "/donasi/import-donation",
                    true
                  )}`}
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                >
                  <NavLink
                    className="menu-link menu-toggle"
                    to="/donasi/import-donation"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Import Donasi</span>
                  </NavLink>
                </li>
              )}

              {/* Rekonsiliasi Donasi */}
              {/*begin::2 Level*/}
              {CheckRole("Read", "rekonsiliasi_donasi") && (
                <>
                  {CheckFeature("SETTLE") && (
                    <>
                      <li
                        className={`menu-item menu-item-submenu ${getMenuItemActive(
                          "/donasi/settlement",
                          true
                        )}`}
                        aria-haspopup="true"
                        data-menu-toggle="hover"
                      >
                        <NavLink
                          className="menu-link menu-toggle"
                          to="/donasi/settlement"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span className="menu-text">Settlement Donasi</span>
                        </NavLink>
                      </li>
                    </>
                  )}
                </>
              )}

              {/* Daftar Donasi */}
              {/*begin::2 Level*/}
              {RoleChecker("Read", "void_donasi") && (
                <li
                  className={`menu-item menu-item-submenu ${getMenuItemActive(
                    "/donasi/delete",
                    true
                  )}`}
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                >
                  <NavLink className="menu-link menu-toggle" to="/donasi/delete">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Delete</span>
                  </NavLink>
                </li>
              )}
              {/*end::2 Level*/}

              {/* Daftar Donasi */}
              {/*begin::2 Level*/}
              {RoleChecker("Read", "void_donasi") && (
                <li
                  className={`menu-item menu-item-submenu ${getMenuItemActive(
                    "/donasi/trash",
                    true
                  )}`}
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                >
                  <NavLink className="menu-link menu-toggle" to="/donasi/trash">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Trash</span>
                  </NavLink>
                </li>
              )}
              {/*end::2 Level*/}
            </ul>
          </div>
        </li>
        {/*end::1 Level*/}

        {/* Donatur */}
        {/*begin::1 Level*/}
        {RoleChecker("Read", "daftar_donatur") && (
          <>
            <li
              className={`menu-item menu-item-submenu ${getMenuItemActive(
                "/donatur",
                true
              )}`}
              aria-haspopup="true"
              data-menu-toggle="hover"
            >
              <NavLink className="menu-link menu-toggle" to="/donatur">
                <span className="svg-icon menu-icon">
                  <SupervisorAccountIcon />
                </span>
                <span className="menu-text">Donatur</span>
              </NavLink>
            </li>
          </>
        )}
        {/*end::1 Level*/}

        {/* Program */}
        {/*begin::1 Level*/}
        {RoleChecker("Read", "project") && (
          <>
            <li
              className={`menu-item menu-item-submenu ${getMenuItemActive(
                "/program",
                true
              )}`}
              aria-haspopup="true"
              data-menu-toggle="hover"
            >
              <NavLink className="menu-link menu-toggle" to="/program">
                <span className="svg-icon menu-icon">
                  <BusinessIcon />
                </span>
                <span className="menu-text">Program</span>
              </NavLink>
            </li>
          </>
        )}
        {/*end::1 Level*/}

        {/* Program */}
        {/*begin::1 Level*/}
        {/* {RoleChecker("Read", "project") && ( */}
        <>
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/organization-report",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink
              className="menu-link menu-toggle"
              to="/organization-report"
            >
              <span className="svg-icon menu-icon">
                <DescriptionIcon />
              </span>
              <span className="menu-text">Laporan Konsolidasi Lembaga</span>
            </NavLink>
          </li>
        </>
        {/* )} */}
        {/*end::1 Level*/}

        {/* KURBAN */}
        {CheckFeature("KURBAN") && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/kurban",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/kurban/list">
              <span className="svg-icon menu-icon">
                <LocalOfferIcon />
              </span>
              <span
                className="menu-text"
                onClick={() => history.push("/kurban/distribution/normal")}
              >
                Kurban
              </span>
              <span className="menu-text" style={{ width: "100px" }}></span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu ">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                {/* Distribusi Normal */}
                {/*begin::2 Level*/}
                {CheckRole("Read", "distribution") && (
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/kurban/distribution/normal",
                      true
                    )}`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <NavLink
                      className="menu-link menu-toggle"
                      to="/kurban/distribution/normal"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Distribusi Normal</span>
                    </NavLink>
                  </li>
                )}
                {/*end::2 Level*/}

                {/* Distribusi 1/7 Sapi */}
                {/*begin::2 Level*/}
                {CheckRole("Read", "distribution") && (
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/kurban/distribution/merging",
                      true
                    )}`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <NavLink
                      className="menu-link menu-toggle"
                      to="/kurban/distribution/merging"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Distribusi 1/7 Sapi</span>
                    </NavLink>
                  </li>
                )}
                {/*end::2 Level*/}

                {/* List Kurban */}
                {/*begin::2 Level*/}
                {CheckRole("Read", "daftar_kurban") && (
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/kurban/list",
                      true
                    )}`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <NavLink
                      className="menu-link menu-toggle"
                      to="/kurban/list"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Donasi Kurban</span>
                    </NavLink>
                  </li>
                )}
                {/*end::2 Level*/}

                {/* Kuota Mitra */}
                {/*begin::2 Level*/}
                {CheckRole("Read", "partner-quota") && (
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/kurban/quota-partner",
                      true
                    )}`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <NavLink
                      className="menu-link menu-toggle"
                      to="/kurban/quota-partner"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Stok Mitra</span>
                    </NavLink>
                  </li>
                )}
                {/*end::2 Level*/}

                {/* Mitra */}
                {/*begin::2 Level*/}
                {CheckRole("Read", "mitra") && (
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/kurban/partner",
                      true
                    )}`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <NavLink
                      className="menu-link menu-toggle"
                      to="/kurban/partner"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Mitra</span>
                    </NavLink>
                  </li>
                )}
                {/*end::2 Level*/}

                {/* Hewan Kurban */}
                {/*begin::2 Level*/}
                {CheckRole("Read", "wilayah") && (
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/kurban/area",
                      true
                    )}`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <NavLink
                      className="menu-link menu-toggle"
                      to="/kurban/area"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Wilayah</span>
                    </NavLink>
                  </li>
                )}
                {/*end::2 Level*/}

                {/* Hewan Kurban */}
                {/*begin::2 Level*/}
                {CheckRole("Read", "hewan_kurban_campaign") && (
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/kurban/campaign-hewan-kurban",
                      true
                    )}`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <NavLink
                      className="menu-link menu-toggle"
                      to="/kurban/campaign-hewan-kurban"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Hewan Kurban</span>
                    </NavLink>
                  </li>
                )}
                {/*end::2 Level*/}

                {/* Kategori Kurban */}
                {/*begin::2 Level*/}
                {CheckRole("Read", "hewan_kurban") && (
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/kurban/hewan-kurban",
                      true
                    )}`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <NavLink
                      className="menu-link menu-toggle"
                      to="/kurban/hewan-kurban"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Kategori Hewan</span>
                    </NavLink>
                  </li>
                )}
                {/*end::2 Level*/}

                {/* Periode Kurban */}
                {/*begin::2 Level*/}
                {CheckRole("Read", "access_role") && (
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/kurban/periode-kurban",
                      true
                    )}`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <NavLink
                      className="menu-link menu-toggle"
                      to="/kurban/periode-kurban"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Periode Kurban</span>
                    </NavLink>
                  </li>
                )}
                {/*end::2 Level*/}

                {/*begin::2 Level*/}
                {/* {RoleChecker("Read", "kurban-report") && (
                <li
                  className={`menu-item menu-item-submenu ${getMenuItemActive(
                    "/kurban/report",
                    true
                  )}`}
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                >
                  <NavLink
                    className="menu-link menu-toggle"
                    to="/kurban/report"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Laporan Kurban</span>
                  </NavLink>
                </li>
              )} */}
              </ul>
            </div>
          </li>
        )}

        {/* Master Data */}
        {/*begin::1 Level*/}
        {RoleChecker("Read", "master_data") && (
          <>
            <li
              className={`menu-item menu-item-submenu`}
              aria-haspopup="true"
              data-menu-toggle="hover"
            >
              <NavLink
                className="menu-link menu-toggle"
                to="/master-data/program"
              >
                <span className="svg-icon menu-icon">
                  <StorageIcon />
                </span>
                {/* <span className="menu-text">Konfigurasi</span> */}
                <span className="menu-text">Pengaturan</span>
                <i className="menu-arrow" />
              </NavLink>
              <div className="menu-submenu ">
                <i className="menu-arrow" />
                <ul className="menu-subnav">
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/master-data/donation",
                      true
                    )}`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <NavLink
                      className="menu-link menu-toggle"
                      to="/master-data/donation/fundtype"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span
                        className="menu-text"
                        onClick={() =>
                          history.push("/master-data/donation/fundtype")
                        }
                      >
                        Donasi
                      </span>
                      <span
                        className="menu-text"
                        style={{ width: "100px" }}
                      ></span>

                      <i className="menu-arrow" />
                    </NavLink>
                    <div className="menu-submenu">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        {/* begin::3 Level */}
                        {/* {RoleChecker("Read", "project") && (
                          <li
                            className={`menu-item ${getMenuItemActive(
                              "/master-data/donation/program"
                            )}`}
                          >
                            <NavLink
                              className="menu-link"
                              to="/master-data/donation/program"
                            >
                              <i className="menu-bullet menu-bullet-dot">
                                <span />
                              </i>
                              <span className="menu-text">Program</span>
                            </NavLink>
                          </li>
                        )} */}
                        {/* end::3 Level */}

                        {/* begin::3 Level */}
                        {RoleChecker("Read", "fund_type") && (
                          <li
                            className={`menu-item ${getMenuItemActive(
                              "/master-data/donation/fundtype"
                            )}`}
                          >
                            <NavLink
                              className="menu-link"
                              to="/master-data/donation/fundtype"
                            >
                              <i className="menu-bullet menu-bullet-dot">
                                <span />
                              </i>
                              <span className="menu-text">Jenis dana</span>
                            </NavLink>
                          </li>
                        )}
                        {/* end::3 Level */}

                        {/* begin::3 Level */}
                        {RoleChecker("Read", "channel") && (
                          <li
                            className={`menu-item ${getMenuItemActive(
                              "/master-data/donation/channel"
                            )}`}
                          >
                            <NavLink
                              className="menu-link"
                              to="/master-data/donation/channel"
                            >
                              <i className="menu-bullet menu-bullet-dot">
                                <span />
                              </i>
                              <span className="menu-text">Channel</span>
                            </NavLink>
                          </li>
                        )}
                        {/* end::3 Level */}
                      </ul>
                    </div>
                  </li>

                  {/* Payment Gateway */}
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/master-data/category",
                      true
                    )}`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <NavLink
                      className="menu-link menu-toggle"
                      to="/master-data/category/benefisCategory"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span
                        className="menu-text"
                        onClick={() =>
                          history.push("/master-data/category/benefisCategory")
                        }
                      >
                        Kategori
                      </span>
                      <span
                        className="menu-text"
                        style={{ width: "100px" }}
                      ></span>

                      <i className="menu-arrow" />
                    </NavLink>
                    <div className="menu-submenu">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        {/*begin::3 Level*/}
                        {RoleChecker("Read", "benefis_category") && (
                          <li
                            className={`menu-item menu-item-submenu ${getMenuItemActive(
                              "/master-data/category/benefisCategory",
                              true
                            )}`}
                            aria-haspopup="true"
                            data-menu-toggle="hover"
                          >
                            <NavLink
                              className="menu-link menu-toggle"
                              to="/master-data/category/benefisCategory"
                            >
                              <i className="menu-bullet menu-bullet-dot">
                                <span />
                              </i>
                              <span className="menu-text">
                                Penerima Manfaat
                              </span>
                            </NavLink>
                          </li>
                        )}
                        {/*end::3 Level*/}

                        {/* begin::3 Level */}
                        {RoleChecker("Read", "kategori_barang") && (
                          <li
                            className={`menu-item ${getMenuItemActive(
                              "/master-data/category/goods-category"
                            )}`}
                          >
                            <NavLink
                              className="menu-link"
                              to="/master-data/category/goods-category"
                            >
                              <i className="menu-bullet menu-bullet-dot">
                                <span />
                              </i>
                              <span className="menu-text">Kategori Barang</span>
                            </NavLink>
                          </li>
                        )}

                        {/* end::3 Level */}
                        {/* begin::3 Level */}

                        {RoleChecker("Read", "master_kategori") && (
                          <li
                            className={`menu-item menu-item-submenu ${getMenuItemActive(
                              "/master-data/category/master-category",
                              true
                            )}`}
                            aria-haspopup="true"
                            data-menu-toggle="hover"
                          >
                            <NavLink
                              className="menu-link menu-toggle"
                              to="/master-data/category/master-category"
                            >
                              <i className="menu-bullet menu-bullet-dot">
                                <span />
                              </i>
                              <span className="menu-text">
                                Kategori Donatur
                              </span>
                            </NavLink>
                          </li>
                        )}
                        {/* begin::3 Level */}

                        {/* Payment Method */}
                        {/*begin::3 Level*/}
                        {/* {RoleChecker("Read", "payment_method") && (
                          <li
                            className={`menu-item menu-item-submenu ${getMenuItemActive(
                              "/master-data/payment-method",
                              true
                            )}`}
                            aria-haspopup="true"
                            data-menu-toggle="hover"
                          >
                            <NavLink
                              className="menu-link menu-toggle"
                              to="/master-data/payment-method"
                            >
                              <i className="menu-bullet menu-bullet-dot">
                                <span />
                              </i>
                              <span className="menu-text">Payment Method</span>
                            </NavLink>
                          </li>
                        )} */}
                      </ul>
                    </div>
                  </li>

                  {/* Bank */}
                  {/*begin::2 Level*/}
                  {RoleChecker("Read", "bank") && (
                    <li
                      className={`menu-item menu-item-submenu ${getMenuItemActive(
                        "/master-data/bank",
                        true
                      )}`}
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                    >
                      <NavLink
                        className="menu-link menu-toggle"
                        to="/master-data/bank/list-bank"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span
                          className="menu-text"
                          onClick={() =>
                            history.push("/master-data/bank/list-bank")
                          }
                        >
                          Bank
                        </span>
                        <span
                          className="menu-text"
                          style={{ width: "100px" }}
                        ></span>

                        <i className="menu-arrow" />
                      </NavLink>
                      <div className="menu-submenu">
                        <i className="menu-arrow" />
                        <ul className="menu-subnav">
                          {/* begin::3 Level */}
                          <li
                            className={`menu-item ${getMenuItemActive(
                              "/master-data/bank/list-bank"
                            )}`}
                          >
                            <NavLink
                              className="menu-link"
                              to="/master-data/bank/list-bank"
                            >
                              <i className="menu-bullet menu-bullet-dot">
                                <span />
                              </i>
                              <span className="menu-text">Bank</span>
                            </NavLink>
                          </li>
                          {/* begin::3 Level */}

                          {/* begin::3 Level */}
                          <li
                            className={`menu-item ${getMenuItemActive(
                              "/master-data/bank/account-bank"
                            )}`}
                          >
                            <NavLink
                              className="menu-link"
                              to="/master-data/bank/account-bank"
                            >
                              <i className="menu-bullet menu-bullet-dot">
                                <span />
                              </i>
                              <span className="menu-text">Rekening Bank</span>
                            </NavLink>
                          </li>
                          {/* begin::3 Level */}
                        </ul>
                      </div>
                    </li>
                  )}
                  {/*end::2 Level*/}

                  {/* Master Kategori */}
                  {/*begin::2 Level*/}
                  {/* {RoleChecker("Read", "master_kategori") && (
                    <li
                      className={`menu-item menu-item-submenu ${getMenuItemActive(
                        "/master-data/master-category",
                        true
                      )}`}
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                    >
                      <NavLink
                        className="menu-link menu-toggle"
                        to="/master-data/master-category"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Kategori Donatur</span>
                      </NavLink>
                    </li>
                  )} */}
                  {/*end::2 Level*/}

                  {/* Kategori Barang */}
                  {/*begin::2 Level*/}
                  {/* {RoleChecker("Read", "kategori_barang") && (
                    <li
                      className={`menu-item menu-item-submenu ${getMenuItemActive(
                        "/master-data/goods-category",
                        true
                      )}`}
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                    >
                      <NavLink
                        className="menu-link menu-toggle"
                        to="/master-data/goods-category"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Kategori Barang</span>
                      </NavLink>
                    </li>
                  )} */}
                  {/*end::2 Level*/}

                  {/* Fund Type */}
                  {/*begin::2 Level*/}
                  {/* {RoleChecker("Read", "fund_type") && (
                    <li
                      className={`menu-item menu-item-submenu ${getMenuItemActive(
                        "/master-data/fundtype",
                        true
                      )}`}
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                    >
                      <NavLink
                        className="menu-link menu-toggle"
                        to="/master-data/fundtype"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Jenis Dana</span>
                      </NavLink>
                    </li>
                  )} */}
                  {/*end::2 Level*/}

                  {/* Bank Account */}

                  {/* {RoleChecker("Read", "bank_account") && (
                    <li
                      className={`menu-item menu-item-submenu ${getMenuItemActive(
                        "/master-data/account-bank",
                        true
                      )}`}
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                    >
                      <NavLink
                        className="menu-link menu-toggle"
                        to="/master-data/account-bank"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Bank Account</span>
                      </NavLink>
                    </li>
                  )} */}

                  {/* Bank Pooling */}
                  {/*begin::2 Level*/}
                  {/* {RoleChecker("Read", "bank_pooling") && (
                    <li
                      className={`menu-item menu-item-submenu ${getMenuItemActive(
                        "/master-data/pooling-bank",
                        true
                      )}`}
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                    >
                      <NavLink
                        className="menu-link menu-toggle"
                        to="/master-data/pooling-bank"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Bank Pooling</span>
                      </NavLink>
                    </li>
                  )} */}
                  {/*end::2 Level*/}

                  {/* Payment Gateway */}
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/master-data/payment",
                      true
                    )}`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <NavLink
                      className="menu-link menu-toggle"
                      to="/master-data/payment/payment-gateway"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span
                        className="menu-text"
                        onClick={() =>
                          history.push("/master-data/payment/payment-gateway")
                        }
                      >
                        Payment
                      </span>
                      <span
                        className="menu-text"
                        style={{ width: "100px" }}
                      ></span>

                      <i className="menu-arrow" />
                    </NavLink>
                    <div className="menu-submenu">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        {/*begin::3 Level*/}
                        {RoleChecker("Read", "payment_gateway") && (
                          <li
                            className={`menu-item menu-item-submenu ${getMenuItemActive(
                              "/master-data/payment/payment-gateway",
                              true
                            )}`}
                            aria-haspopup="true"
                            data-menu-toggle="hover"
                          >
                            <NavLink
                              className="menu-link menu-toggle"
                              to="/master-data/payment/payment-gateway"
                            >
                              <i className="menu-bullet menu-bullet-dot">
                                <span />
                              </i>
                              <span className="menu-text">Payment Gateway</span>
                            </NavLink>
                          </li>
                        )}
                        {/*end::3 Level*/}

                        {/* Payment Method */}
                        {/*begin::3 Level*/}
                        {RoleChecker("Read", "payment_method") && (
                          <li
                            className={`menu-item menu-item-submenu ${getMenuItemActive(
                              "/master-data/payment/payment-method",
                              true
                            )}`}
                            aria-haspopup="true"
                            data-menu-toggle="hover"
                          >
                            <NavLink
                              className="menu-link menu-toggle"
                              to="/master-data/payment/payment-method"
                            >
                              <i className="menu-bullet menu-bullet-dot">
                                <span />
                              </i>
                              <span className="menu-text">Payment Method</span>
                            </NavLink>
                          </li>
                        )}
                      </ul>
                    </div>
                  </li>

                  {/* Template Notifikasi */}
                  {/*begin::2 Level*/}
                  {RoleChecker("Read", "template_notifikasi") && (
                    <>
                      <li
                        className={`menu-item menu-item-submenu ${getMenuItemActive(
                          "/master-data/notifikasi",
                          true
                        )}`}
                        aria-haspopup="true"
                        data-menu-toggle="hover"
                      >
                        <NavLink
                          className="menu-link menu-toggle"
                          to="/master-data/notifikasi/template-notifikasi"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span className="menu-text">Template Notifikasi</span>
                          {/* <i className="menu-arrow" /> */}
                        </NavLink>
                        {/* <div className="menu-submenu ">
                          <i className="menu-arrow" />
                          <ul className="menu-subnav">
                            begin::3 Level
                            <li
                              className={`menu-item  ${getMenuItemActive(
                                "/master-data/notifikasi/template-notifikasi"
                              )}`}
                              aria-haspopup="true"
                            >
                              <NavLink
                                className="menu-link"
                                to="/master-data/notifikasi/template-notifikasi"
                              >
                                <i className="menu-bullet menu-bullet-dot">
                                  <span />
                                </i>
                                <span className="menu-text">
                                  Template Notifikasi
                                </span>
                              </NavLink>
                            </li>
                            end::3 Level
                          </ul>
                        </div> */}
                      </li>
                    </>
                  )}
                  {/*end::2 Level*/}

                  {/* {RoleChecker("Read", "channel") && (
                    <li
                      className={`menu-item menu-item-submenu ${getMenuItemActive(
                        "/master-data/channel",
                        true
                      )}`}
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                    >
                      <NavLink
                        className="menu-link menu-toggle"
                        to="/master-data/channel"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Channel</span>
                      </NavLink>
                    </li>
                  )} */}
                  {/*end::2 Level*/}

                  {/* {RoleChecker("Read", "master_option") && (
                    <li
                      className={`menu-item menu-item-submenu ${getMenuItemActive(
                        "/master-data/master-option",
                        true
                      )}`}
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                    >
                      <NavLink
                        className="menu-link menu-toggle"
                        to="/master-data/master-option"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Master Option</span>
                      </NavLink>
                    </li>
                  )} */}

                  {RoleChecker("Edit", "organization") && (
                    <li
                      className={`menu-item menu-item-submenu ${getMenuItemActive(
                        "/master-data/organization",
                        true
                      )}`}
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                    >
                      <NavLink
                        className="menu-link menu-toggle"
                        to="/master-data/organization"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Lembaga</span>
                      </NavLink>
                    </li>
                  )}
                  {/*end::2 Level*/}

                  {/* Branch */}
                  {/*begin::2 Level*/}
                  {/* {RoleChecker("Read", "branch") && (
                    <li
                      className={`menu-item menu-item-submenu ${getMenuItemActive(
                        "/master-data/branchs",
                        true
                      )}`}
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                    >
                      <NavLink
                        className="menu-link menu-toggle"
                        to="/master-data/branchs"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Branch</span>
                      </NavLink>
                    </li>
                  )} */}
                  {/*end::2 Level*/}

                  {/* Project */}
                  {/*begin::2 Level*/}
                  {/* {RoleChecker("Read", "checker") && (
                    <li
                      className={`menu-item menu-item-submenu ${getMenuItemActive(
                        "/master-data/projects",
                        true
                      )}`}
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                    >
                      <NavLink
                        className="menu-link menu-toggle"
                        to="/master-data/projects"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Project</span>
                      </NavLink>
                    </li>
                  )} */}
                  {/*end::2 Level*/}

                  {/* Department */}
                  {/*begin::2 Level*/}
                  {/* {RoleChecker("Read", "department") && (
                    <li
                      className={`menu-item menu-item-submenu ${getMenuItemActive(
                        "/master-data/department",
                        true
                      )}`}
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                    >
                      <NavLink
                        className="menu-link menu-toggle"
                        to="/master-data/department"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Department</span>
                      </NavLink>
                    </li>
                  )} */}
                  {/*end::2 Level*/}

                  {/* Auto Settle */}
                  {/*begin::2 Level*/}
                  {/* {RoleChecker("Read", "auto_settle") && (
                    <li
                      className={`menu-item menu-item-submenu ${getMenuItemActive(
                        "/master-data/auto-settle",
                        true
                      )}`}
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                    >
                      <NavLink
                        className="menu-link menu-toggle"
                        to="/master-data/auto-settle"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Auto Settle</span>
                      </NavLink>
                    </li>
                  )} */}
                  {/*end::2 Level*/}

                  {/* OAuth App */}
                  {/*begin::2 Level*/}
                  {/* {RoleChecker("Read", "oauth_app") && (
                    <li
                      className={`menu-item menu-item-submenu ${getMenuItemActive(
                        "/master-data/oauth-app",
                        true
                      )}`}
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                    >
                      <NavLink
                        className="menu-link menu-toggle"
                        to="/master-data/oauth-app"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">OAuth App</span>
                      </NavLink>
                    </li>
                  )} */}
                  {/*end::2 Level*/}

                  {/* Master Option */}
                  {/*begin::2 Level*/}
                  {/* {RoleChecker("Read", "master_option") && (
                    <li
                      className={`menu-item menu-item-submenu ${getMenuItemActive(
                        "/master-data/master-option",
                        true
                      )}`}
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                    >
                      <NavLink
                        className="menu-link menu-toggle"
                        to="/master-data/master-option"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Master Option</span>
                      </NavLink>
                    </li>
                  )} */}
                  {/*end::2 Level*/}
                </ul>
              </div>
            </li>
          </>
        )}
        {/*end::1 Level*/}

        {/* Akses */}
        <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/access",
            true
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to="/access/user">
            <span className="svg-icon menu-icon">
              <AccessibilityNewIcon />
            </span>
            <span
              className="menu-text"
              onClick={() => history.push("/access/user")}
            >
              Akses
            </span>
            <span className="menu-text" style={{ width: "100px" }}></span>
            <i className="menu-arrow" />
          </NavLink>
          <div className="menu-submenu ">
            <i className="menu-arrow" />
            <ul className="menu-subnav">
              {/* User */}
              {/*begin::2 Level*/}
              {RoleChecker("Read", "user") && (
                <li
                  className={`menu-item menu-item-submenu ${getMenuItemActive(
                    "/access/user",
                    true
                  )}`}
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                >
                  <NavLink className="menu-link menu-toggle" to="/access/user">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">User</span>
                  </NavLink>
                </li>
              )}
              {/*end::2 Level*/}

              {/* Access Role */}
              {/*begin::2 Level*/}
              {RoleChecker("Read", "access_role") && (
                <li
                  className={`menu-item menu-item-submenu ${getMenuItemActive(
                    "/access/access-role",
                    true
                  )}`}
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                >
                  <NavLink
                    className="menu-link menu-toggle"
                    to="/access/access-role"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Access Role</span>
                  </NavLink>
                </li>
              )}
              {/*end::2 Level*/}
            </ul>
          </div>
        </li>

        {/* Analisa */}
        {/*begin::1 Level*/}
        {RoleChecker("Read", "analisa") && (
          <>
            <li
              className={`menu-item menu-item-submenu ${getMenuItemActive(
                "/analysis",
                true
              )}`}
              aria-haspopup="true"
              data-menu-toggle="hover"
            >
              <NavLink
                className="menu-link menu-toggle"
                to="/analysis/counter/recap"
              >
                <span className="svg-icon menu-icon">
                  <ShowChartIcon />
                </span>
                <span
                  className="menu-text"
                  onClick={() => history.push("/analysis/counter/recap")}
                >
                  Laporan
                </span>
                <span className="menu-text" style={{ width: "100px" }}></span>
                <i className="menu-arrow" />
              </NavLink>
              <div className="menu-submenu ">
                <i className="menu-arrow" />
                <ul className="menu-subnav">
                  {/* Rekapan Donasi */}
                  {/*begin::2 Level*/}
                  {RoleChecker("Read", "rekap_donasi") && (
                    <li
                      className={`menu-item menu-item-submenu ${getMenuItemActive(
                        "/analysis/counter/recap",
                        true
                      )}`}
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                    >
                      <NavLink
                        className="menu-link menu-toggle"
                        to="/analysis/counter/recap"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Rekapan Donasi</span>
                      </NavLink>
                    </li>
                  )}
                  {/*end::2 Level*/}

                  {/* Analisis Pertumbuhan Donatur */}
                  {/*begin::2 Level*/}
                  {RoleChecker("Read", "analisis_pertumbuhan_donatur") && (
                    <li
                      className={`menu-item menu-item-submenu ${getMenuItemActive(
                        "/analysis/donor-growth",
                        true
                      )}`}
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                    >
                      <NavLink
                        className="menu-link menu-toggle"
                        to="/analysis/donor-growth"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Pertumbuhan Donatur</span>
                      </NavLink>
                    </li>
                  )}
                  {/*end::2 Level*/}

                  {/* Analisis Ranking Donasi Donatur Berdasarkan Item Donasi */}
                  {/*begin::2 Level*/}
                  {RoleChecker(
                    "Read",
                    "analisis_ranking_donasi_donatur_berdasarkan_nominal"
                  ) && (
                    <li
                      className={`menu-item menu-item-submenu ${getMenuItemActive(
                        "/analysis/donor-ranking/nominal/total_donasi",
                        true
                      )}`}
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                    >
                      <NavLink
                        className="menu-link menu-toggle"
                        to="/analysis/donor-ranking/nominal/total_donasi"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          Ranking Donasi Donatur Berdasarkan Nominal
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {/*end::2 Level*/}

                  {/* Analisis Ranking Donasi Donatur Berdasarkan Item Donasi */}
                  {/*begin::2 Level*/}
                  {RoleChecker(
                    "Read",
                    "analisis_ranking_donasi_donatur_berdasarkan_item_donasi"
                  ) && (
                    <li
                      className={`menu-item menu-item-submenu ${getMenuItemActive(
                        "/analysis/donor-ranking/donation-item/frekuensi_donasi",
                        true
                      )}`}
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                    >
                      <NavLink
                        className="menu-link menu-toggle"
                        to="/analysis/donor-ranking/donation-item/frekuensi_donasi"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          Ranking Donasi Donatur Berdasarkan Item Donasi
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {/*end::2 Level*/}

                  {/* Analisis Keaktifan Donatur */}
                  {/*begin::2 Level*/}
                  {RoleChecker("Read", "analisis_keaktifan_donatur") && (
                    <li
                      className={`menu-item menu-item-submenu ${getMenuItemActive(
                        "/analysis/donor-active",
                        true
                      )}`}
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                    >
                      <NavLink
                        className="menu-link menu-toggle"
                        to="/analysis/donor-active"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Keaktifan Donatur</span>
                      </NavLink>
                    </li>
                  )}
                  {/*end::2 Level*/}

                  {/* Analisis Perolehan Berdasarkan Konter, Gerai dan Kantor Kas */}
                  {/*begin::2 Level*/}
                  {RoleChecker("Read", "analisis_ranking_perolehan_konter") && (
                    <li
                      className={`menu-item menu-item-submenu ${getMenuItemActive(
                        "/analysis/counter-ranking",
                        true
                      )}`}
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                    >
                      <NavLink
                        className="menu-link menu-toggle"
                        to="/analysis/counter-ranking"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          Perolehan Berdasarkan Konter, Gerai dan Kantor Kas
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {/*end::2 Level*/}

                  {/* Analisis Data Donatur Berdasarkan Jenis Donasi */}
                  {/*begin::2 Level*/}
                  {RoleChecker(
                    "Read",
                    "analisis_data_donatur_berdasarkan_jenis_donasi"
                  ) && (
                    <li
                      className={`menu-item menu-item-submenu ${getMenuItemActive(
                        "/analysis/donor-analysis/donation-type",
                        true
                      )}`}
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                    >
                      <NavLink
                        className="menu-link menu-toggle"
                        to="/analysis/donor-analysis/donation-type"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          Data Donatur Berdasarkan Jenis Donasi
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {/*end::2 Level*/}

                  {/* Analisis Data Donatur Berdasarkan Wilayah */}
                  {/*begin::2 Level*/}
                  {RoleChecker(
                    "Read",
                    "analisis_data_donatur_berdasarkan_wilayah"
                  ) && (
                    <li
                      className={`menu-item menu-item-submenu ${getMenuItemActive(
                        "/analysis/donor-analysis/donor-area",
                        true
                      )}`}
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                    >
                      <NavLink
                        className="menu-link menu-toggle"
                        to="/analysis/donor-analysis/donor-area"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          Data Donatur Berdasarkan Wilayah
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {/*end::2 Level*/}
                </ul>
              </div>
            </li>
          </>
        )}
        {/*end::1 Level*/}
        {/* {RoleChecker("Edit", "organization") && (
          <>
            <li
              className={`menu-item menu-item-submenu ${getMenuItemActive(
                "/organization",
                true
              )}`}
              aria-haspopup="true"
              data-menu-toggle="hover"
            >
              <NavLink className="menu-link menu-toggle" to="/organization">
                <span className="svg-icon menu-icon">
                  <SupervisorAccountIcon />
                </span>
                <span className="menu-text">Organization</span>
              </NavLink>
            </li>
          </>
        )} */}

        {/* Daftar Export */}
        {/*begin::1 Level*/}
        {/* {RoleChecker("Read", "daftar_export") && (
          <>
            <li
              className={`menu-item menu-item-submenu ${getMenuItemActive(
                "/export-list",
                true
              )}`}
              aria-haspopup="true"
              data-menu-toggle="hover"
            >
              <NavLink className="menu-link menu-toggle" to="/export-list">
                <span className="svg-icon menu-icon">
                  <ImportExportIcon />
                </span>
                <span className="menu-text">Daftar Export</span>
              </NavLink>
            </li>
          </>
        )} */}
        {/*end::1 Level*/}

        <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/_distribution",
            true
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink
            className="menu-link menu-toggle"
            to="/_distribution/project"
          >
            <span className="svg-icon menu-icon">
              <CallSplitIcon />
            </span>
            <span
              className="menu-text"
              onClick={() => history.push("/_distribution/project")}
            >
              Penyaluran
            </span>
            <span className="menu-text" style={{ width: "100px" }}></span>
            <i className="menu-arrow" />
          </NavLink>
          <div className="menu-submenu ">
            <i className="menu-arrow" />
            <ul className="menu-subnav">
              {/* Proyek */}
              {/*begin::2 Level*/}
              {/* {RoleChecker("Read", "user") && ( */}
              <li
                className={`menu-item menu-item-submenu ${getMenuItemActive(
                  "/_distribution/project",
                  true
                )}`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink
                  className="menu-link menu-toggle"
                  to="/_distribution/project"
                >
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">Proyek</span>
                </NavLink>
              </li>
              {/* )} */}
              {/*end::2 Level*/}

              {/* Penerima Manfaat */}
              {/*begin::2 Level*/}
              {RoleChecker("Read", "benefis") && (
                <li
                  className={`menu-item menu-item-submenu ${getMenuItemActive(
                    "/_distribution/benefis",
                    true
                  )}`}
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                >
                  <NavLink
                    className="menu-link menu-toggle"
                    to="/_distribution/benefis"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Penerima Manfaat</span>
                  </NavLink>
                </li>
              )}

              {/* Kategori Proyek */}
              {/*begin::2 Level*/}
              {RoleChecker("Read", "project") && (
                <li
                  className={`menu-item menu-item-submenu ${getMenuItemActive(
                    "/_distribution/category",
                    true
                  )}`}
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                >
                  <NavLink
                    className="menu-link menu-toggle"
                    to="/_distribution/category"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Kategori Penyaluran</span>
                  </NavLink>
                </li>
              )}
              {/*end::2 Level*/}

              {/* Penerima Manfaat */}
              {/*begin::2 Level*/}
              {/* {RoleChecker("Read", "access_role") && ( */}
              {/* <li
                className={`menu-item menu-item-submenu ${getMenuItemActive(
                  "/distribution/benefis",
                  true
                )}`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink
                  className="menu-link menu-toggle"
                  to="/distribution/benefis"
                >
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">Penerima Manfaat</span>
                </NavLink>
              </li> */}
              {/* )} */}
              {/*end::2 Level*/}
            </ul>
          </div>
        </li>
        {/* Hide Campaign */}
        {/* {RoleChecker("Read", "campaign") && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/campaign",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/campaign/batch">
              <span className="svg-icon menu-icon">
                <ShareIcon />
              </span>
              <span
                className="menu-text"
                onClick={() => history.push("/campaign/batch")}
              >
                Campaign
              </span>
              <span className="menu-text" style={{ width: "100px" }}></span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu ">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                Campaign
                begin::2 Level
                {RoleChecker("Read", "kirim_campaign") && (
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/campaign/batch",
                      false
                    )}`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <NavLink
                      className="menu-link menu-toggle"
                      to="/campaign/batch"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Kirim Campaign</span>
                    </NavLink>
                  </li>
                )}
                Template
                begin::2 Level
                {RoleChecker("Read", "template_campaign") && (
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/campaign/template",
                      false
                    )}`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <NavLink
                      className="menu-link menu-toggle"
                      to="/campaign/template"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Template</span>
                    </NavLink>
                  </li>
                )}
                end::2 Level
              </ul>
            </div>
          </li>
        )} */}

        {/* Library */}
        {/*begin::1 Level*/}
        <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/elibrary",
            true
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to="/elibrary">
            <span className="svg-icon menu-icon">
              <FolderIcon />
            </span>
            <span className="menu-text">E-Library</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/* Billing */}
        {/* <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/billing",
            true
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to="/billing">
            <span className="svg-icon menu-icon">
              <MonetizationOnIcon />
            </span>
            <span
              className="menu-text"
              onClick={() => history.push("/billing/list")}
            >
              Billing
            </span>
            <span className="menu-text" style={{ width: "100px" }}></span>
            <i className="menu-arrow" />
          </NavLink>
          <div className="menu-submenu ">
            <i className="menu-arrow" />
            <ul className="menu-subnav">
              Invoice
              begin::2 Level
              <li
                className={`menu-item menu-item-submenu ${getMenuItemActive(
                  "/billing/plan-balance",
                  true
                )}`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink
                  className="menu-link menu-toggle"
                  to="/billing/plan-balance"
                >
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">Kuota</span>
                </NavLink>
              </li>
              end::2 Level

              Invoice
              begin::2 Level
              <li
                className={`menu-item menu-item-submenu ${getMenuItemActive(
                  "/billing/list",
                  true
                )}`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink className="menu-link menu-toggle" to="/billing/list">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">Invoice</span>
                </NavLink>
              </li>
              end::2 Level

              Usage
              begin::2 Level
              <li
                className={`menu-item menu-item-submenu ${getMenuItemActive(
                  "/billing/plan-usage-log",
                  true
                )}`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink
                  className="menu-link menu-toggle"
                  to="/billing/plan-usage-log"
                >
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">Riwayat Penggunaan</span>
                </NavLink>
              </li>
              end::2 Level

              Top Up
              begin::2 Level
              <li
                className={`menu-item menu-item-submenu ${getMenuItemActive(
                  "/billing/top-up",
                  true
                )}`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink className="menu-link menu-toggle" to="/billing/top-up">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">Top Up</span>
                </NavLink>
              </li>
              end::2 Level
            </ul>
          </div>
        </li> */}
      </ul>

      {/* end::Menu Nav */}
    </>
  );
}
